package ru.malygin.myConst

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import ru.malygin.dto.MainScheduleItemDto

data class LastDocInfo(
    val lastTime: Long? = null,
    val url: String? = null,
    val title: String? = null,
)

data class SettingsInfo(
    val settingsId:Int,
    val tableName: String,
    val lastDocInfo: LastDocInfo,
)

data class ConverterAxes(
    val row: Int,
    val column: Int
)

data class TimeDetectorItem(
    val targetDay:Int,// 0 1
    val dateAndNameOfDay:String,// 15 апреля
    val onlyDateOfDay:String,// 15.04.2024
    val nameOfDay:WeekDay,// Понедельник
    val dayByNumber: String = "0",// 15
)

@Serializable
data class ScheduleChange(
    @Serializable
    @SerialName("category")
    val category: SelectedCategory,

    @Serializable
    @SerialName("dto_item")
    val dtoItem: List<DtoItemSubInfo>
)

@Serializable
data class DtoItemSubInfo(
    @Serializable
    @SerialName("name")
    val name: String,

    @Serializable
    @SerialName("sub_info")
    val subInfo: String?= null
)

data class SupportForList(
    val id: Int,
    val counter: Int?,
    val dataForOne: MainScheduleItemDto?,
    val dataForMore: List<MainScheduleItemDto>? = null
)

data class UrlLocal(
    val text: String,
    val url: String
)

